import { IndustryTemplate } from '@/components';
import { handymanContent } from '@/data/industries/handyman';

export function HandymanPage() {
  return <IndustryTemplate content={handymanContent} />;
}
